import { render, staticRenderFns } from "./ProdesCerrado2021.vue?vue&type=template&id=4eee5008&lang=pug"
import script from "./ProdesCerrado2021.vue?vue&type=script&lang=js"
export * from "./ProdesCerrado2021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports